/**
 * Mobile Dock + Mobile Search
 * Version: 4.0 - Com overlay e preço corrigido
 */

(function() {
  'use strict';

  class MobileDock {
    constructor() {
      this.dock = document.getElementById('MobileDock');
      this.searchHeader = document.getElementById('MobileSearchHeader');
      this.searchInput = document.getElementById('MobileSearchInput');
      this.searchClose = document.getElementById('MobileSearchClose');
      this.searchResults = document.getElementById('MobileSearchResults');
      this.searchLoading = document.getElementById('MobileSearchLoading');
      this.overlay = null;
      
      if (!this.dock) return;
      
      this.searchTimeout = null;
      this.init();
    }

    init() {
      this.createOverlay();
      this.bindEvents();
    }

    createOverlay() {
      // Cria overlay para clicar fora e fechar
      this.overlay = document.createElement('div');
      this.overlay.className = 'mobile-search-overlay';
      this.overlay.id = 'MobileSearchOverlay';
      document.body.appendChild(this.overlay);
      
      // Click no overlay fecha
      this.overlay.addEventListener('click', () => this.closeSearch());
    }

    bindEvents() {
      // Botão de busca - abre o search header
      const searchBtn = this.dock.querySelector('[data-dock-open-search]');
      if (searchBtn) {
        searchBtn.addEventListener('click', () => this.openSearch());
      }

      // Fechar search
      if (this.searchClose) {
        this.searchClose.addEventListener('click', () => this.closeSearch());
      }

      // Input search
      if (this.searchInput) {
        this.searchInput.addEventListener('input', (e) => this.handleSearchInput(e));
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeSearch();
        });
      }

      // ESC fecha search
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.searchHeader?.classList.contains('is-open')) {
          this.closeSearch();
        }
      });

      // Cart update
      document.addEventListener('cart:updated', () => this.updateCartBadge());
      
      // Touch feedback
      const items = this.dock.querySelectorAll('[data-dock-item]');
      items.forEach(item => {
        item.addEventListener('touchstart', () => item.style.transform = 'scale(0.9)', { passive: true });
        item.addEventListener('touchend', () => item.style.transform = '', { passive: true });
      });
    }

    openSearch() {
      if (!this.searchHeader) return;
      
      // Mostra overlay
      this.overlay?.classList.add('is-open');
      
      // Mostra search header
      this.searchHeader.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      
      // Esconde o dock temporariamente
      this.dock.style.transform = 'translateY(100%)';
      
      setTimeout(() => {
        this.searchInput?.focus();
      }, 350);
    }

    closeSearch() {
      if (!this.searchHeader) return;
      
      // Esconde overlay
      this.overlay?.classList.remove('is-open');
      
      // Esconde search header
      this.searchHeader.classList.remove('is-open');
      document.body.style.overflow = '';
      
      // Mostra o dock novamente
      this.dock.style.transform = '';
      
      // Limpa
      if (this.searchInput) this.searchInput.value = '';
      if (this.searchResults) this.searchResults.innerHTML = '';
    }

    handleSearchInput(e) {
      const query = e.target.value.trim();
      
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      
      if (!query || query.length < 2) {
        if (this.searchResults) this.searchResults.innerHTML = '';
        return;
      }
      
      this.searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    }

    async performSearch(query) {
      if (!this.searchResults) return;
      
      this.searchLoading?.classList.add('is-loading');
      
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
        );
        
        if (!response.ok) throw new Error('Search failed');
        
        const data = await response.json();
        this.renderResults(data.resources?.results?.products || []);
        
      } catch (error) {
        console.error('Search error:', error);
        this.searchResults.innerHTML = '<div class="search-empty">Erro ao buscar. Tente novamente.</div>';
      } finally {
        this.searchLoading?.classList.remove('is-loading');
      }
    }

    renderResults(products) {
      if (!this.searchResults) return;
      
      if (products.length === 0) {
        this.searchResults.innerHTML = '<div class="search-empty">Nenhum produto encontrado.</div>';
        return;
      }
      
      const html = products.map(product => {
        // Usa o preço formatado que vem da API ou formata corretamente
        const price = this.formatPrice(product.price_min || product.price);
        
        return `
          <a href="${product.url}" class="search-result-item">
            ${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy">` : '<div style="width:52px;height:52px;background:#f0f0f0;border-radius:10px;"></div>'}
            <div>
              <p class="search-result-item__title">${product.title}</p>
              <p class="search-result-item__price">${price}</p>
            </div>
          </a>
        `;
      }).join('');
      
      this.searchResults.innerHTML = html;
    }

    formatPrice(price) {
      // Se o preço já é uma string formatada, retorna
      if (typeof price === 'string' && price.includes('R$')) {
        return price;
      }
      
      // Se é um número, pode ser centavos OU reais
      // A API do Shopify retorna em centavos para algumas moedas
      // mas para BRL geralmente já vem multiplicado por 100
      
      let numericPrice = parseFloat(price);
      
      // Se o número é muito grande (ex: 12900 para R$129,00), divide por 100
      // Se é pequeno (ex: 129), usa direto
      // Heurística: se > 1000 e termina em 00, provavelmente está em centavos
      if (numericPrice > 1000) {
        numericPrice = numericPrice / 100;
      }
      
      // Formata para BRL
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(numericPrice);
    }

    async updateCartBadge() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const badge = this.dock.querySelector('[data-cart-count]');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        }
      } catch (error) {
        console.error('Failed to update cart badge:', error);
      }
    }
  }

  function init() {
    new MobileDock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();